import { render, staticRenderFns } from "./ModalBattlesSelect.vue?vue&type=template&id=2e44d4d0&scoped=true"
import script from "./ModalBattlesSelect.vue?vue&type=script&lang=js"
export * from "./ModalBattlesSelect.vue?vue&type=script&lang=js"
import style0 from "./ModalBattlesSelect.vue?vue&type=style&index=0&id=2e44d4d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e44d4d0",
  null
  
)

export default component.exports